import React from 'react'

import { StepItemProps, StepItem } from './partials'

export interface StepsProps {
    /**
     * These are the steps that are displayed and it's an array of objects.
     * The shape of the objest is:
     * {
     *  name: string,
     *  href: string,
     *  status: 'todo' | 'current' | 'complete'
     *  index: number
     * }
     */
    steps: StepItemProps[]

    /**
     * This makes it possible to pass through additional props.
     */
    [propName: string]: any
}

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export function Steps(props: StepsProps) {
    const { steps, ...rest } = props
    return (
        <nav aria-label="Progress" {...rest}>
            <ol className="flex items-center">
                {steps.map((step, stepIdx) => (
                    <li
                        key={step.name}
                        className={classNames(
                            stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-24' : '',
                            'relative'
                        )}
                    >
                        <StepItem {...step} />
                    </li>
                ))}
            </ol>
        </nav>
    )
}
